import React from 'react';
import ActionIconButton from './ActionIconButton';

const ConfirmButton = ({title = 'Confirmar', ...props}) => (
    <ActionIconButton variant="confirm" title={title} {...props}/>
);

export default ConfirmButton;
